export const FEATURE_NAME = 'infoItems';

export const LIST = 'list';
export const REQUEST_DATA = 'requestData';

export const MESSAGE = 'message';
export const FILES = 'files';

export const INFO_BOX = 'infobox';
